import { toast } from "sonner";
import { supabase } from "@/integrations/supabase/client";
import { BUILD_ID } from "@/lib/buildVersion";

function getBuildId() { return BUILD_ID; }

/**
 * Show an error toast with a "Signaler" action button.
 * When clicked, it creates a report in the admin signalements tab
 * with the attempted action and error details.
 *
 * @param message - User-facing message
 * @param action - What the user was trying to do (e.g. "Créer une invitation")
 * @param errorDetail - Technical error detail (e.g. error.message)
 */
export function toastError(
  message: string,
  action: string,
  errorDetail?: string
) {
  toast.error(message, {
    action: {
      label: "Signaler",
      onClick: () => reportError(action, errorDetail || message),
    },
  });
}

/**
 * Show an info-level toast (for "blocked" states) with a "Signaler" button.
 */
export function toastBlocked(
  message: string,
  action: string,
  errorDetail?: string
) {
  toast.info(message, {
    action: {
      label: "Signaler",
      onClick: () => reportError(action, errorDetail || message),
    },
  });
}

async function reportError(action: string, details: string) {
  const {
    data: { user },
  } = await supabase.auth.getUser();
  if (!user) {
    toast.error("Connexion requise pour signaler.");
    return;
  }
  const { error } = await supabase.from("reports").insert({
    created_by: user.id,
    target_type: "system",
    target_id: "error",
    reason: `Erreur lors de : ${action}`,
    details: `Action : ${action}\nDétail : ${details}\nPage : ${window.location.pathname}\nDate : ${new Date().toISOString()}\nBuild : ${getBuildId()}`,
  });
  if (error) toast.error("Impossible d'envoyer le signalement.");
  else toast.success("Signalement envoyé, merci !");
}
